import React = require('react');
import { UskinnedBaseBtnClassNames } from '../models/button';

export interface ILinkButtonProps {
  target?: string;
  href: string;
  className?: string;
}

export enum ButtonType {
  Submit = 'submit',
  Button = 'button'
}

export interface IButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  type?: ButtonType;
  className?: string;
}

export const LinkButton = ({
  children,
  href,
  target = '_blank',
  className = ''
}: React.PropsWithChildren<ILinkButtonProps>) => (
  <a className={`${UskinnedBaseBtnClassNames} ${className}`} href={href} target={target}>
    <span aria-hidden='true'>&nbsp;</span>
    {children}
  </a>
);

export const Button = ({
  children,
  onClick = () => {},
  disabled = false,
  type = ButtonType.Button,
  className = ''
}: React.PropsWithChildren<IButtonProps>) => (
  <button
    className={`${UskinnedBaseBtnClassNames} ${className}`}
    onClick={event => onClick(event)}
    disabled={disabled}
    type={type}
  >
    <span aria-hidden='true'>&nbsp;</span>
    {children}
  </button>
);
